import { Offcanvas, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LegacyPaginator from 'components/others/Paginator';
import type { ComponentType } from 'react';
import type { PaginatorType } from '@econtractor/types';
import spinnerTitle from 'components/others/spinnerTitle';
import WarrantyTable from '../WarrantyTable';
import { useObjectWarranties } from './model';

const Paginator = LegacyPaginator as ComponentType<{
    paginator: PaginatorType;
    onChangePage: (page: number) => void;
    showPageSize: boolean;
}>;

interface OffAttachWarrantiesProps {
    show: boolean;
    objectId: number;
    onClose: () => void;
    onSaved: () => void;
}

const OffAttachWarranties = ({ show, objectId, onClose, onSaved }: OffAttachWarrantiesProps) => {
    const { t } = useTranslation('Warranties');
    const state = useObjectWarranties(objectId, true, onSaved, show);
    return (
        <Offcanvas show={show} placement="end" onHide={onClose} className="off-warranty-select">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{t('attachTitle')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pb-0 px-0 d-flex flex-column">
                <div className="off-coming-content px-3">
                    <Form.Control
                        className="mb-3"
                        aria-label={t('search')}
                        placeholder={t('search')}
                        value={state.search}
                        onChange={(e) => state.setSearch(e.target.value)}
                    />
                    <WarrantyTable
                        mini
                        hideActions
                        rows={state.result?.warranties || []}
                        loading={state.loading}
                        selected={state.selected}
                        onSelect={state.toggle}
                    />
                </div>
                <div className="p-3 offcanvas-footer off-coming-footer d-flex flex-wrap align-items-center justify-content-between gap-3">
                    {state.result && (
                        <div className="mw-100">
                            <Paginator
                                paginator={state.result.paginator}
                                onChangePage={state.setPage}
                                showPageSize={false}
                            />
                        </div>
                    )}
                    <Button
                        variant="info"
                        className="ms-auto min100px flex-shrink-0"
                        disabled={state.loading || !state.selected.length}
                        onClick={async () => {
                            if (await state.mutate(state.selected)) onClose();
                        }}
                    >
                        {spinnerTitle(
                            `${t('attach')} (${state.selected.length})`,
                            state.loading,
                            t('saving'),
                        )}
                    </Button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffAttachWarranties;
